import React from 'react';
import apiPath from 'apiPath';
import axios from 'axios';
import { Form, Input, Icon, Button, message, Alert } from 'antd';

import { formItemLayout, tailFormItemLayout } from './formItemLayout.js';

const hasErrors = (fieldsError) => {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class DepositLogin extends React.Component {

    state = {
        bookingId : null
    }

    //get email and password and submit(lowercase)
    handleSubmit = (event) => {
        event.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                axios.post(apiPath + '/auth/loginDeposit', {
                    Email: values.email.toLowerCase(),
                    DepositCode: values.depositCode
                }, {
                        withCredentials: true
                    }).then(result => {
                        this.setState({bookingId : result.request.statusText})
                        this.props.history.push('/depositform')
                    }).catch(error => {
                        console.error(error);
                        message.error('Invalid credentials');
                    });
            }
        })
    }
    componentDidMount() {
        this.props.form.validateFields();
    }
    render() {
        const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
        const userNameError = isFieldTouched('userName') && getFieldError('userName');
        const passwordError = isFieldTouched('password') && getFieldError('password');
        return (
            <div>
                <Alert showIcon type="info"
                    message={<span>Please use the email that you put down on your application and the deposit code that was included in your acceptance email.</span>}
                />
                <br />
                <Form layout="horizontal" onSubmit={this.handleSubmit}>
                    <Form.Item label="Email"
                        validateStatus={userNameError ? 'error' : ''}
                        help={userNameError || ''}
                        {...formItemLayout}>

                        {getFieldDecorator('email', {
                            rules: [
                                { required: true, message: 'Email address is required' }
                            ],
                        })(
                            <Input prefix={<Icon type="mail" />} />
                        )}

                    </Form.Item>
                    <Form.Item label="Deposit Code"
                        validateStatus={passwordError ? 'error' : ''}
                        help={passwordError || ''}
                        {...formItemLayout}>

                        {getFieldDecorator('depositCode', {
                            rules: [{ required: true, message: 'Deposit Code is required' }],
                        })(
                            <Input prefix={<Icon type="lock" />} />
                        )}

                    </Form.Item>
                    <Form.Item {...tailFormItemLayout}>
                        <Button type="primary" htmlType="submit" id="submit_button" disabled={hasErrors(getFieldsError())}>
                            Deposit
					</Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}

export default Form.create()(DepositLogin);



// WEBPACK FOOTER //
// ./src/containers/Login/DepositLogin.jsx